<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="回满所需成长币数量" prop="revertAllCredit">
        <el-input-number v-model="form.revertAllCredit" :min="0" :max="1000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="每日首次首充数量(折扣)" prop="revertAllDayFirst">
        <el-input-number v-model="form.revertAllDayFirst" :min="0" :max="1000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="体力值恢复间隔时间(s)" prop="revertIntervalTime">
        <el-input-number v-model="form.revertIntervalTime" :min="0" :max="30000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="每次恢复数量" prop="revertIntervalValue">
        <el-input-number  v-model="form.revertIntervalValue" :min="0" :max="1000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="提交任务扣减数量" prop="taskDeductCount">
        <el-input-number v-model="form.taskDeductCount" :min="0" :max="1000" label="描述文字"></el-input-number>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          :disabled="time"
          v-model="form.createTime"
          type="datetime"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker
          :disabled="time"
          v-model="form.updateTime"
          type="datetime"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button
        type="primary"
        v-permission:function="['energyManger:btn_update']"
        @click="getUpdate('form')"
      >更新</el-button>
      <el-button type="info" @click="getReset('form')">重置</el-button>
    </div>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getList, getSet } from '@/api/demo/energy/index'
export default {
  name: 'energyManger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      energyManger_btn_update: false,
      form: {
        revertAllCredit: '', // 回满所需成长币数量
        revertAllDayFirst: '', // 每日首次回满折扣
        revertIntervalTime: '', // 体力值恢复间隔时间
        revertIntervalValue: '', // 每次恢复数量
        taskDeductCount: '' // 提交任务扣减数量
      },
      time: true,
      rules: {}
    }
  },
  created () {
    this.getEnergyList()
  },
  watch: {},
  methods: {
    getEnergyList () {
      let that = this
      getList().then(res => {
        that.form = res
      })
    },
    getUpdate (forms) {
      let that = this
      that
        .$confirm('此操作将永久更改, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          that.$refs[forms].validate(async valid => {
            if (valid) {
              await getSet(that.form)
              that.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000
              })
              that.getEnergyList()
            }
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getReset () {
      this.getEnergyList()
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
</style>
